import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import "./DepositView.css";

import { IoMdRefresh } from "react-icons/io";
import { FaClock } from "react-icons/fa6";
import { IoIosSearch } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";

import { styled } from "@mui/system";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { RiDeleteBack2Fill } from "react-icons/ri";
import { FaEye } from "react-icons/fa6";

import ReconnectingWebSocket from "reconnecting-websocket";

import Select from "@mui/material/Select";

import "tom-select/dist/css/tom-select.css";

import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

import DataGrid, {
  Export,
  Selection,
  GroupPanel,
  Paging,
  Pager,
  Scrolling,
  ColumnFixing,
  SearchPanel,
  Column,
  HeaderFilter,
  FilterRow,
  Toolbar,
} from "devextreme-react/data-grid";
import TagBox from "devextreme-react/tag-box";

import Popup from "devextreme-react/popup";
import Divider from "@mui/material/Divider";
import { RiArrowRightDoubleFill } from "react-icons/ri";
import { MdCancel } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";

// import "devextreme/dist/css/dx.light.css";

import { NumericFormat } from "react-number-format";
// import { Button } from "devextreme-react/button";
import NumberBox from "devextreme-react/number-box";

import Accordion, { Item } from "devextreme-react/accordion";

import { BsSendArrowUpFill } from "react-icons/bs";
import { RiUserReceivedFill } from "react-icons/ri";
import { GrTarget } from "react-icons/gr";
import { BsPencilSquare } from "react-icons/bs";
import { FaDownload } from "react-icons/fa";
import CircularProgress from "@mui/material/CircularProgress";

import { TextBox } from "devextreme-react/text-box";

import { useSelector } from "react-redux";
import { showNotification } from "../components/NotificationProvider";

import { useDispatch } from "react-redux";
import {
  getDepositQueue,
  getMe,
  getUserDepositHistory,
  getDepositMedia,
  clearDepositMedia,
} from "../store";

import Button from "@mui/material/Button";
import { FaCheck } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { AiOutlineMessage } from "react-icons/ai";
import { MdRoomPreferences } from "react-icons/md";
import { FiTarget } from "react-icons/fi";
import { RiProgress5Line } from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import { MdOutlinePending } from "react-icons/md";
import { MdOutlineDoNotDisturbOff } from "react-icons/md";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { CgDetailsMore } from "react-icons/cg";
import { FcApproval } from "react-icons/fc";

import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import ContextMenu from "devextreme-react/context-menu";
import _ from "lodash";

import { IoIosNotifications, IoIosNotificationsOff } from "react-icons/io";

const notificationSound = new Audio("/sounds/notify.mp3");
const highAmountSound = new Audio("/sounds/sound2.mp3");

// Ses dosyalarını önceden yükle ve hata yönetimi ekle
notificationSound.preload = "auto";
highAmountSound.preload = "auto";

notificationSound.onerror = (e) => {
  console.error("Notification sound failed to load:", e);
};

highAmountSound.onerror = (e) => {
  console.error("High amount sound failed to load:", e);
};

const CustomAmountTextField = ({ value, onChange, placeholder }) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    const regex = /^[0-9]*[.,]?[0-9]*$/;

    if (regex.test(inputValue)) {
      onChange(e);
    }
  };

  return (
    <OutlinedInput
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      sx={{
        backgroundColor: "#1B2434",
        borderRadius: "4px", // Input'un köşelerini hafif yuvarlamak için
        color: "#dedede",
        height: "4rem",
        fontSize: "1.6rem",
        marginRight: "1rem",
        width: "15rem",

        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#29364a",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#225978",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#19a9dd",
          borderWidth: "1px",
        },
        "& .MuiInputBase-input": {
          color: "#dedede",
          fontSize: "1.6rem",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#afafaf",
          fontSize: "1.6rem",
        },
      }}
      endAdornment={
        value && (
          <InputAdornment position="end">
            <IconButton
              aria-label="clear input"
              onClick={() => onChange({ target: { value: "" } })}
              edge="end"
            >
              <RiDeleteBack2Fill color="#afafaf" />
            </IconButton>
          </InputAdornment>
        )
      }
    />
  );
};

const dataSource = [];

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#82828282",
    },
    "&:hover fieldset": {
      borderColor: "#1c77d25e",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1c77d25e",
    },
    height: "4rem",
    width: "15rem",
    overflow: "hidden",
  },
  "& .MuiInputBase-input": {
    fontSize: "18px",
    color: "white",
    backgroundColor: "#1B2434",
    padding: ".9rem",
    textAlign: "center",
  },
  "& .MuiInputLabel-root": {
    fontSize: "18px",
    color: "white",
    scale: "0.73",
  },
});

const depositsArray = [];

const customStore = new CustomStore({
  key: "id",
  load: () => {
    return depositsArray.map((deposit) => ({
      id: deposit._id,
      method: deposit.method,
      transaction_id: deposit.transactionId,
      trader: deposit.traderName,
      host_user_id: deposit.userId,
      host_user_name: deposit.userId,
      sender_full_name: deposit.cardInfo?.name || "N/A",
      amount: deposit.amount,
      isAmountChanged: deposit.isAmountChanged,
      oldAmount: deposit.oldAmount,
      recipient: deposit.recipientName,
      recipient_account: deposit.recipientAccount,
      create_date: deposit.createdAt,
      status: deposit.status,
      smsStatus: deposit.smsStatus,
      smsCode: deposit.smsCode,
      reservedPerson: deposit.reservedPerson,
      reservedPersonName: deposit.reservedPersonName,
      // rezerv: deposit.reservedPerson,
      detail: "Detail",
    }));
  },
  byKey: (key) => {
    // Find and return the deposit with the given key
    const deposit = depositsArray.find((item) => item._id === key);
    return deposit
      ? Promise.resolve(deposit)
      : Promise.reject(new Error("Deposit not found (Store)"));
  },
  insert: (values) => {
    depositsArray.push(values);
    return Promise.resolve(); // Promise döndürmek, işlemin tamamlandığını belirtir
  },
  update: (key, values) => {
    const index = depositsArray.findIndex((item) => item._id === key);
    depositsArray[index] = { ...depositsArray[index], ...values };
    return Promise.resolve();
  },
  remove: (key) => {
    const index = depositsArray.findIndex((item) => item._id === key);

    if (index !== -1) {
      depositsArray.splice(index, 1);
      return Promise.resolve();
    }

    return Promise.resolve();
  },
});

const DepositView = () => {
  const { user } = useSelector((state) => state.user);
  const { isLoading, depositMedia, mediaLoading } = useSelector(
    (state) => state.deposits
  );

  const dispatch = useDispatch();
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);
  const [tableHeight, setTableHeight] = useState(window.innerHeight);

  const [changeAmountPopupVisible, setChangeAmountPopupVisible] =
    useState(false);
  const [detailPopupVisible, setDetailPopupVisible] = useState(false);
  const [manualAccessPopupVisible, setManualAccessPopupVisible] =
    useState(false);
  const [manualAccessCode, setManualAccessCode] = useState("");
  const [isApproveDisabled, setIsApproveDisabled] = useState(true);
  const [isSoundEnabled, setIsSoundEnabled] = useState(() => {
    const savedSoundSetting = localStorage.getItem("depositSoundEnabled");
    return savedSoundSetting ? JSON.parse(savedSoundSetting) : true; // Varsayılan olarak açık
  });

  useEffect(() => {
    const handleResize = () => {
      const remInPx = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );
      const newHeight = window.innerHeight - 7 * remInPx;
      setContainerHeight(newHeight);

      const newTableHeight = window.innerHeight - 16.5 * remInPx;
      setTableHeight(newTableHeight);
    };

    // Set initial height
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--lolo", `${tableHeight}px`);
  }, [tableHeight]);

  const [dataGridSource, setDataGridSource] = useState(dataSource);

  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);
  const [confirmationAction, setConfirmationAction] = useState("approve"); // "approve" or "stealthApprove"
  const [declinePopupVisible, setDeclinePopupVisible] = useState(false);
  const [historyPopupVisible, setHistoryPopupVisible] = useState(false);

  const [personId, setPersonId] = useState("");
  const [myPermissions, setMyPermissions] = useState("");
  const [dropPermission, setDropPermission] = useState(false);
  const [wsIsOpen, setWsIsOpen] = useState(false);

  useEffect(() => {
    if (user && user.user) {
      setPersonId(user.user._id);
      setDropPermission(user.user.dropDepositPermission);
      setMyPermissions(user.user.permissions);

      // Kullanıcının yetkili olduğu trader'ları set et
      if (user.user.traders && Array.isArray(user.user.traders)) {
        setUserTraders(user.user.traders);
        // Başlangıçta tüm trader'ları seçili olarak ayarla
        const allTraderIds = user.user.traders.map((trader) => trader._id);
        setTraderFilterType(allTraderIds);
      }
    }
  }, [user]);

  const getDeposits = async () => {
    try {
      depositsArray.length = 0;

      const res = await dispatch(getDepositQueue()).unwrap();

      // setDeposits(res.data.data.deposits);

      const deposits = res.data.data.deposits;

      const insertPromises = deposits.map((deposit) => {
        const newRow = { ...deposit };
        return customStore.insert(newRow);
      });

      handleFilterChange("Free and My Transactions");

      await Promise.all(insertPromises);
      dxSource.reload();
    } catch (error) {
      console.error("Failed to fetch deposits", error);
    }
  };

  useEffect(() => {
    getDeposits();
  }, [dispatch]);

  const handleRefreshClick = () => {
    const allIds = depositsArray.map((deposit) => deposit._id);

    const removePromises = allIds.map((id) => {
      return customStore.remove(id); // Her ID'yi siliyoruz
    });

    Promise.all(removePromises)
      .then(() => {
        dxSource.reload(); // Grid'i yeniden yükler
        getDeposits();
        showNotification("Success", "success", "Deposits refreshed");
      })
      .catch((error) => {
        showNotification("Error", "error", "Failed to refresh deposits");
        console.error("Error while removing deposits: ", error);
      });

    // getDeposits();
    // showNotification("Success", "success", "Deposits refreshed");
  };

  const handleManualAccessCodeChange = (e) => {
    setManualAccessCode(e.target.value);
  };

  const handleShowUserHistory = () => {
    setHistoryPopupVisible(true);
  };

  const handleChangeAmountPopupHidden = useCallback(() => {
    setChangeAmountPopupVisible(false);
    setAmount(null);
    setSender(null);
    setRecipient(null);
    setNewAmount(null);
  }, [setChangeAmountPopupVisible]);

  const handleDetailPopupHidden = useCallback(() => {
    setDetailPopupVisible(false);
    setSelectedDeposit(null);
    setSmsReqButtonDisabled(false);
    setIsManualSms(false);
    setExplanation("");
    setApproveButtonDisabled(true);
    dispatch(clearDepositMedia());
  }, [setDetailPopupVisible, dispatch]);

  //TODO:
  const handleHistoryPopupHidden = useCallback(() => {
    setHistoryPopupVisible(false);
    setSelectedUserId(null);
    setSelectedUserName(null);
    setSelectedUserTrader(null);
  }, [setHistoryPopupVisible]);

  const handleManualAccessPopupHidden = useCallback(() => {
    setManualAccessPopupVisible(false);
  }, [setManualAccessPopupVisible]);

  const handleConfirmationPopupHidden = useCallback(() => {
    setConfirmationPopupVisible(false);
  }, [setConfirmationPopupVisible]);

  const handleDeclinePopupHidden = useCallback(() => {
    setDeclinePopupVisible(false);
  }, [setDeclinePopupVisible]);

  const handleManualAccessClick = () => {
    setManualAccessPopupVisible(true);
  };

  const onSelectionChanged = useCallback(({ selectedRowsData }) => {
    const data = selectedRowsData[0];
  });

  const [socket, setSocket] = useState(null);
  const [deposits, setDeposits] = useState([]);
  const dataGridSourceMemo = useMemo(() => dataGridSource, [dataGridSource]);
  // const [explanation, setExplanation] = useState("");
  const [selectedDepositId, setSelectedDepositId] = useState(null);

  const [depositIdforAmount, setDepositIdforAmount] = useState(null);
  const [amount, setAmount] = useState(null);
  const [sender, setSender] = useState(null);
  const [recipient, setRecipient] = useState(null);
  const [newAmount, setNewAmount] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [gridFilterSelectedValue, setGridFilterSelectedValue] =
    useState("All Transactions");
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [smsReqButtonDisabled, setSmsReqButtonDisabled] = useState(false);
  const [isManualSms, setIsManualSms] = useState(false);
  const [approveButtonDisabled, setApproveButtonDisabled] = useState(true);

  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");

  const [dxSource, setDxSource] = useState(
    new DataSource({ store: customStore })
  );

  // TEST ADD ROW
  // const handleAddRow = () => {
  //   const intervalId = setInterval(() => {}, 50);

  //   setTimeout(() => {
  //     clearInterval(intervalId);
  //   }, 60000);
  // };

  // const applyGridSource = (filterType) => {
  //   if (deposits.length > 0) {
  //     let formattedData = deposits.map((deposit, index) => ({
  //       id: deposit._id,
  //       transaction_id: deposit.transactionId,
  //       trader: deposit.traderName,
  //       host_user_id: deposit.userId,
  //       host_user_name: deposit.userId,
  //       sender_full_name: deposit.cardInfo?.name || "N/A",
  //       amount: new Intl.NumberFormat("tr-TR", {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2,
  //       }).format(deposit.amount),
  //       isAmountChanged: deposit.isAmountChanged,
  //       oldAmount: deposit.oldAmount,
  //       recipient: deposit.recipientName,
  //       recipient_account: deposit.recipientAccount,
  //       create_date: deposit.createdAt,
  //       status: deposit.smsStatus,
  //       smsCode: deposit.smsCode,
  //       reservedPerson: deposit.reservedPerson,
  //       reservedPersonName: deposit.reservedPersonName,
  //       rezerv: deposit.reservedPerson,
  //       detail: "Detail",
  //     }));

  //     if (minAmount !== undefined && minAmount !== "" && !isNaN(minAmount)) {
  //       formattedData = formattedData.filter(
  //         (item) => item.amount >= parseFloat(minAmount)
  //       );
  //     }
  //     if (maxAmount !== undefined && maxAmount !== "" && !isNaN(maxAmount)) {
  //       formattedData = formattedData.filter(
  //         (item) => item.amount <= parseFloat(maxAmount)
  //       );
  //     }

  //     if (filterType === "Free and My Transactions") {
  //       formattedData = formattedData.filter(
  //         (item) => !item.reservedPerson || item.reservedPerson === personId
  //       );
  //     } else if (filterType === "My Transactions") {
  //       formattedData = formattedData.filter(
  //         (item) => item.reservedPerson === personId
  //       );
  //     } else if (filterType === "Free Transactions") {
  //       formattedData = formattedData.filter((item) => !item.reservedPerson);
  //     }

  //     setDataGridSource(formattedData);
  //   } else {
  //     setDataGridSource([]);
  //     setTotalAmount(0);
  //   }
  // };

  //   // 200ms aralıklı veri işleme
  // const throttle = (func, limit) => {
  //   let inThrottle;
  //   return function () {
  //     const args = arguments;
  //     const context = this;
  //     if (!inThrottle) {
  //       func.apply(context, args);
  //       inThrottle = true;
  //       setTimeout(() => (inThrottle = false), limit);
  //     }
  //   };
  // };
  //   const throttledHandleNewDeposit = throttle(handleNewDeposit, 200);

  const selectedDepositRef = useRef(null);
  const isSoundEnabledRef = useRef(isSoundEnabled);

  useEffect(() => {
    isSoundEnabledRef.current = isSoundEnabled;
  }, [isSoundEnabled]);

  useEffect(() => {
    selectedDepositRef.current = selectedDeposit;
  }, [selectedDeposit]);

  useEffect(() => {
    if (personId) {
      const ws = new WebSocket(`${process.env.REACT_APP_BASE_URL_WS}/ws/panel`);
      let pingInterval;

      ws.onopen = () => {
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.log("Connected to panel WebSocket");
        }
        setWsIsOpen(true);

        pingInterval = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: "ping" }));
          }
        }, 30000);

        // ws.send(JSON.stringify({ type: "sendPersonId", personId }));
        // if (personId !== "") {
        //   const message = JSON.stringify({
        //     type: "sendPersonId",
        //   });
        //   ws.send(message);
        //   console.log("PersonId sent to backend: ", personId);
        // }
      };

      ws.onmessage = (message) => {
        const data = JSON.parse(message.data);

        if (data.type === "pong") {
          if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
            console.log("Received pong from server");
          }
          return;
        }

        switch (data.type) {
          case "personIdReceived":
            if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
              console.log(data.message);
            }
            break;

          case "newDeposit":
            // throttledHandleNewDeposit(data.deposit);
            // setDeposits((prevDeposits) => [...prevDeposits, data.deposit]);

            const newRow = { ...data.deposit };
            customStore.insert(newRow).then(() => {
              dxSource.reload();
            });

            if (isSoundEnabledRef.current) {
              try {
                notificationSound.play().catch((error) => {
                  console.error("Failed to play notification sound:", error);
                });
              } catch (error) {
                console.error("Error playing notification sound:", error);
              }
            }

            break;

          case "reservedByPerson":
            customStore
              .update(data.depositId, {
                reservedPerson: data.reservedPerson,
                reservedPersonName: data.reservedPersonName,
                status: data.status,
              })
              .then(() => {
                dxSource.reload();
              });

            break;
          case "reserveResult":
            if (data.message === "Reserved successfully") {
              showNotification(
                "Success",
                "success",
                "Deposit reserved successfully."
              );
            } else {
              showNotification("Error", "danger", data.message);
            }
            break;

          case "smsStatusUpdate":
            customStore
              .update(data.depositId, {
                smsStatus: data.smsStatus,
              })
              .then(() => {
                dxSource.reload();
              });

            break;

          case "smsRequestResult": // Add this new case
            showNotification(
              data.message.includes("success") ? "Success" : "Error",
              data.message.includes("success") ? "success" : "danger",
              data.message
            );
            break;

          case "smsCodeReceived":
            customStore
              .update(data.depositId, {
                smsStatus: data.smsStatus,
                smsCode: data.smsCode,
              })
              .then(() => {
                dxSource.reload();
              });

            if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
              console.log(selectedDepositRef.current?._id);
            }
            if (data.depositId === selectedDepositRef.current?._id) {
              // const smsArea = document.querySelector(
              //   ".deposit-detail-sms-area"
              // );
              // if (smsArea) {
              //   smsArea.textContent = `${data.smsCode}`; // Update content as needed
              //   showNotification("Success", "success", "SMS code received");
              //   setApproveButtonDisabled(false);
              // }

              setSelectedDeposit((prevDeposit) => ({
                ...prevDeposit,
                smsCode: data.smsCode,
              }));

              showNotification("Success", "success", "SMS code received");
              setApproveButtonDisabled(false);
            }
            break;

          case "setManualSmsResult":
            showNotification(
              data.message.includes("success") ? "Success" : "Error",
              data.message.includes("success") ? "success" : "danger",
              data.message
            );
            break;

          case "amountChanged":
            customStore
              .update(data.depositId, {
                amount: data.amount,
                oldAmount: data.oldAmount,
                isAmountChanged: data.isAmountChanged,
              })
              .then(() => {
                dxSource.reload();
              });

            break;

          case "amountChangeResult":
            if (data.message === "Amount changed successfully") {
              showNotification("Success", "success", data.message);
            } else {
              showNotification("Error", "danger", data.message);
            }
            break;

          case "depositDropped":
            customStore
              .update(data.depositId, {
                ...data.deposit,
              })
              .then(() => {
                dxSource.reload();
              });

            break;

          case "dropDepositResult":
            if (data.message === "Deposit dropped successfully") {
              showNotification("Success", "success", data.message);
            } else {
              showNotification("Error", "danger", data.message);
            }
            break;

          case "depositApproved":
            customStore.remove(data.depositId).then(() => {
              dxSource.reload();
            });

            // setDeposits((prevDeposits) =>
            //   prevDeposits.filter((deposit) => deposit._id !== data.depositId)
            // );

            break;

          case "approveResult":
            if (data.message === "Deposit approved successfully") {
              showNotification("Success", "success", data.message);
            } else {
              showNotification("Error", "danger", data.message);
            }
            break;

          case "depositDeclined":
            if (data.explanation === "Deposit abandoned by user") {
              // showNotification("Error", "danger", data.explanation);
            }
            customStore.remove(data.depositId).then(() => {
              dxSource.reload();
            });

            break;

          case "c2cDepositCanceled":
            customStore.remove(data.depositId).then(() => {
              dxSource.reload();
            });
            break;

          case "declineResult":
            // showNotification("Success", "success", data.message);
            if (data.message === "Deposit declined successfully") {
              showNotification("Success", "success", data.message);
            } else {
              showNotification("Error", "danger", data.message);
            }
            break;

          case "depositNotFound":
            customStore.remove(data.depositId).then(() => {
              dxSource.reload();
            });

            break;

          case "reserveDepositNotFound":
            showNotification(
              "Error",
              "danger",
              "Deposit not found, it will be removed from the queue."
            );
            break;

          case "highAmountDeposit":
            showNotification(
              "High Amount Alert",
              "warning",
              `${data.message} - Amount: ${data.amount} AZN - Trader: ${data.traderName}`
            );

            if (isSoundEnabledRef.current) {
              try {
                highAmountSound.play().catch((error) => {
                  console.error("Failed to play high amount sound:", error);
                });
              } catch (error) {
                console.error("Error playing high amount sound:", error);
              }
            }

            console.log(
              `High amount deposit notification received: ${data.amount} AZN from ${data.traderName}`
            );
            break;

          case "error":
            showNotification("Error", "danger", data.message);
            break;

          case "depositFinish":
            break;

          default:
            if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
              console.log("Unknown message type:", data.type);
            }
            showNotification("Error", "danger", "Unknown message type");
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      ws.onclose = () => {
        clearInterval(pingInterval);
        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
          console.log("WebSocket connection closed");
        }
      };

      setSocket(ws);

      return () => {
        clearInterval(pingInterval);
        ws.close();
      };
    }
  }, [personId]);

  useEffect(() => {
    if (
      wsIsOpen &&
      socket &&
      socket.readyState === WebSocket.OPEN &&
      personId
    ) {
      handleSendPersonId();
    }
  }, [wsIsOpen, socket?.readyState, personId]);

  const handleSendPersonId = useCallback(() => {
    if (personId && socket?.readyState === WebSocket.OPEN) {
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(
          "%cPersonId sent to backend: %c" + personId,
          "color: #2196F3; font-weight: bold",
          "color: #4CAF50"
        );
      }
      try {
        socket.send(
          JSON.stringify({
            type: "sendPersonId",
            personId: personId,
          })
        );
      } catch (error) {
        console.error("Failed to send personId to WebSocket", error);
        showNotification(
          "Error",
          "Error",
          "Failed to send personId to WebSocket."
        );
      }
    } else if (!personId) {
      showNotification("Error", "Error", "User not found, please login again.");
    }
  }, [personId, socket]);

  useEffect(() => {
    if (selectedDeposit) {
      const updatedDeposit = deposits.find(
        (deposit) => deposit._id === selectedDeposit._id
      );
      if (updatedDeposit) {
        setSelectedDeposit(updatedDeposit);
      }
    }
  }, [deposits, selectedDeposit?._id]);

  const handleReserve = (depositId) => {
    if (!myPermissions.includes("Deposit")) {
      showNotification(
        "Error",
        "danger",
        "You do not have permission to reserve deposits."
      );
      return;
    }

    if (personId !== "") {
      if (socket) {
        try {
          socket.send(JSON.stringify({ type: "reserve", depositId, personId }));
          dxSource.reload();
        } catch (error) {
          console.error("Failed to reserve deposit", error);
          showNotification(
            "Error",
            "danger",
            "Invalid request, please log in again."
          );
        }
      }
    } else {
      showNotification("error", "Error", "User not found, please login again");
    }
  };

  const handleDetailClick = (id) => {
    customStore
      .byKey(id)
      .then((tempDeposit) => {
        if (tempDeposit) {
          setSelectedDeposit(tempDeposit);
          selectedDepositRef.current = tempDeposit;

          const senderCardNumber = tempDeposit?.cardInfo?.number;
          if (senderCardNumber && senderCardNumber.startsWith("4098")) {
            setIsManualSms(true);
          }

          // Load media for c2c and c2c/p2p transactions
          if (
            tempDeposit?.method === "c2c" ||
            tempDeposit?.method === "c2c/p2p"
          ) {
            dispatch(getDepositMedia(tempDeposit.transactionId));
          }
        } else {
          console.error("Deposit not found (Detail Click)");
          showNotification(
            "Error",
            "danger",
            "Deposit not found, socket stuck, please refresh the page."
          );
        }
      })
      .catch((error) => {
        console.error("Failed to retrieve deposit", error);
        showNotification(
          "Error",
          "danger",
          "Deposit not found, socket stuck, please refresh the page."
        );
      });
  };

  useEffect(() => {
    if (selectedDeposit) {
      setDetailPopupVisible(true);
      if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
        console.log(selectedDeposit);
      }
    }
  }, [selectedDeposit]);

  const handleGetSms = (depositId) => {
    if (personId !== "") {
      try {
        if (socket) {
          socket.send(JSON.stringify({ type: "getSms", depositId, personId }));
          setSmsReqButtonDisabled(true);
          showNotification(
            "Success",
            "success",
            "SMS request successfully sent"
          );
        }
      } catch (error) {
        console.error("Failed to get sms", error);
        showNotification(
          "Error",
          "Error",
          "Invalid request, please log in again."
        );
      }
    } else {
      showNotification("error", "Error", "User not found, please login again");
    }
  };

  const handleSetManualSms = (depositId) => {
    if (manualAccessCode === "11111") {
      setApproveButtonDisabled(false);

      setSelectedDeposit((prev) => ({
        ...prev,
        smsCode: "11111",
      }));

      setIsManualSms(false);
      setManualAccessPopupVisible(false);
      showNotification("Success", "success", "Manual SMS code accepted");
    } else {
      showNotification("Error", "danger", "Invalid manual access code");
    }
  };

  const handleApprove = (depositId) => {
    if (socket) {
      try {
        socket.send(
          JSON.stringify({
            type: "depositApproved",
            depositId,
            personId,
          })
        );

        setConfirmationPopupVisible(false);
        setDetailPopupVisible(false);
      } catch (error) {
        console.error("Failed to approve deposit", error);
        showNotification(
          "Error",
          "danger",
          "Invalid request, please log in again."
        );
      }
    }
  };

  const handleStealthApprove = (depositId) => {
    if (socket) {
      try {
        socket.send(
          JSON.stringify({
            type: "depositStealthApproved",
            depositId,
            personId,
          })
        );

        setConfirmationPopupVisible(false);
        setDetailPopupVisible(false);
      } catch (error) {
        console.error("Failed to stealth approve deposit", error);
        showNotification(
          "Error",
          "danger",
          "Invalid request, please log in again."
        );
      }
    }
  };

  const handleDecline = (depositId) => {
    if (socket) {
      try {
        socket.send(
          JSON.stringify({
            type: "depositDeclined",
            depositId,
            personId,
            explanation,
          })
        );
        setDeclinePopupVisible(false);
        setDetailPopupVisible(false);
      } catch (error) {
        console.error("Failed to decline deposit", error);
        showNotification(
          "Error",
          "danger",
          "Invalid request, please log in again."
        );
      }
    } else {
      showNotification(
        "Error",
        "danger",
        "Websocket is not connected, please refresh the page."
      );
    }
  };

  const handleAmountChangePopup = (id) => {
    customStore
      .byKey(id)
      .then((tempDeposit) => {
        if (tempDeposit) {
          if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
            console.log(tempDeposit);
          }
          setDepositIdforAmount(tempDeposit._id);

          setAmount(
            tempDeposit.oldAmount ? tempDeposit.oldAmount : tempDeposit.amount
          );
          setNewAmount(tempDeposit.amount);
          setSender(tempDeposit.cardInfo?.name);
          setRecipient(tempDeposit.recipientName);
          setChangeAmountPopupVisible(true);
        } else {
          console.error("Deposit not found (Amount Change)");
        }
      })
      .catch((error) => {
        console.error("Failed to retrieve deposit", error);
        showNotification(
          "Error",
          "danger",
          "Deposit not found, socket stuck, please refresh the page."
        );
      });
  };

  const handleChangeAmount = (depositId, newAmount) => {
    // console.log(depositId, newAmount);
    // const difference = Math.abs(amount - newAmount);
    // if (difference > 10) {
    //   showNotification(
    //     "Error",
    //     "danger",
    //     "New amount must be within ±10 of the current amount."
    //   );
    //   return;
    // }

    if (socket) {
      try {
        socket.send(
          JSON.stringify({
            type: "amountChangeRequest",
            depositId,
            personId,
            newAmount: newAmount,
          })
        );
        setChangeAmountPopupVisible(false);
        setAmount(null);
        setSender(null);
        setRecipient(null);
        setNewAmount(null);
      } catch (error) {
        console.error("Failed to change amount", error);
        showNotification(
          "Error",
          "danger",
          "Invalid request, please log in again."
        );
      }
    }
  };

  const handleDropDeposit = (depositId) => {
    if (!dropPermission) {
      showNotification(
        "Error",
        "danger",
        "You do not have permission to drop deposits."
      );
      return; // Exit the function if the user does not have "Deposit" permission
    }

    if (socket) {
      try {
        socket.send(
          JSON.stringify({
            type: "dropDepositRequest",
            depositId,
            personId,
          })
        );
      } catch (error) {
        console.error("Failed to drop deposit", error);
        showNotification(
          "Error",
          "danger",
          "Invalid request, please log in again."
        );
      }
    }
  };

  const canDrop = (deposit) =>
    deposit?.reservedPerson === personId && dropPermission;

  const handleAmountChangeBlur = () => {};

  const formatCardNumber = (number) => {
    return number.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const renderChangeAmountPopup = useCallback(
    () => (
      <div className="popup-amount-change">
        <div className="popup-body-top-container">
          <div className="popup-body-left">
            <span className="popup-sender popup-person-title popup-sender-title">
              Sender
            </span>
            <span className="popup-sender popup-person-name popup-sender-name">
              {sender}
            </span>
          </div>
          <div className="popup-body-center">
            <div className="popup-brand">PrimeProPay</div>
            <RiArrowRightDoubleFill className="popup-transfer-icon" />
            <div className="popup-amount">
              {amount
                ? new Intl.NumberFormat("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(amount)
                : ""}{" "}
              ₼
            </div>
          </div>
          <div className="popup-body-right">
            <span className="popup-sender popup-person-title popup-receipent-title">
              Receipent
            </span>
            <span className="popup-sender popup-person-name popup-receipent-name">
              {recipient}
            </span>
          </div>
        </div>
        <div className="popup-body-bottom-container">
          {/* <CustomTextField
            InputProps={{
              inputComponent: ManatNumberFormat,
            }}
            variant="outlined"
            label="New Amount"
            value={newAmount}
            onChange={(e) => setNewAmount(e.target.value)}
          /> */}
          <NumberBox
            value={newAmount}
            format="#,##0.00 ₼"
            showSpinButtons={true}
            valueChangeEvent="input"
            onValueChange={(e) => setNewAmount(e)}
            onFocusOut={handleAmountChangeBlur}
          />
        </div>
        <Divider
          orientation="horizontal"
          variant="middle"
          flexItem
          sx={{ borderColor: "#ffffff14", margin: "30px 0 10px 0" }}
        />
        <div className="popup-footer">
          <div className="popup-footer-left">
            <Button
              variant="outlined"
              color="error"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
              }}
              onClick={() => setChangeAmountPopupVisible(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="popup-footer-right">
            <Button
              variant="outlined"
              color="success"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
                backgroundColor: "#73B816",
                "&:hover": {
                  backgroundColor: "#73B816",
                },
              }}
              onClick={() => handleChangeAmount(depositIdforAmount, newAmount)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    ),
    [amount, sender, recipient, newAmount, depositIdforAmount]
  );

  const DetailPopup = React.memo(
    ({
      selectedDeposit,
      onClose,
      smsReqButtonDisabled,
      isManualSms,
      approveButtonDisabled,
      explanation, // Passed from parent
      setExplanation, // Passed from parent
      setFullScreenImage, // Passed from parent
    }) => {
      const isC2C = selectedDeposit?.method === "c2c";
      const isC2CP2P = selectedDeposit?.method === "c2c/p2p";
      const isMediaMode = isC2C || isC2CP2P; // Both methods use media display mode

      // Media preview component for c2c and c2c/p2p transactions

      const MediaPreview = () => {
        if (mediaLoading) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "2rem",
              }}
            >
              <CircularProgress />
              <span style={{ marginLeft: "1rem", color: "#dedede" }}>
                Loading receipt...
              </span>
            </div>
          );
        }

        if (!depositMedia?.data?.data?.media) {
          return (
            <div
              style={{ padding: "2rem", textAlign: "center", color: "#cecece" }}
            >
              No receipt available for this transaction
            </div>
          );
        }

        const media = depositMedia.data.data.media;
        const isImage = media.contentType.startsWith("image/");
        const isPDF = media.contentType === "application/pdf";

        // Both c2c and c2c/p2p now use media.url (base64 format from backend)
        // Backend proxies Telegram images and returns them as base64
        const mediaUrl = media.url;

        const downloadMedia = () => {
          const link = document.createElement("a");
          link.href = mediaUrl;
          link.download =
            media.filename || `receipt-${selectedDeposit?.transactionId}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };

        const openFullScreen = () => {
          if (isImage) {
            setFullScreenImage(mediaUrl);
          }
        };

        return (
          <div style={{ padding: "0.5rem" }}>
            {isImage && (
              <div
                style={{
                  textAlign: "center",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <img
                  src={mediaUrl}
                  alt="Receipt"
                  onClick={openFullScreen}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "250px",
                    borderRadius: "8px",
                    border: "1px solid #ffffff14",
                    cursor: "pointer",
                    transition: "opacity 0.3s ease",
                    display: "block",
                  }}
                  onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
                  onMouseLeave={(e) => (e.target.style.opacity = "1")}
                />
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    downloadMedia();
                  }}
                  sx={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    backgroundColor: "rgba(25, 118, 210, 0.8)",
                    backdropFilter: "blur(4px)",
                    minWidth: "36px",
                    width: "36px",
                    height: "36px",
                    padding: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    "&:hover": {
                      backgroundColor: "rgba(21, 101, 192, 0.9)",
                    },
                  }}
                >
                  <FaDownload size={14} />
                </Button>
              </div>
            )}
            {isPDF && (
              <div style={{ textAlign: "center", padding: "1rem" }}>
                <div style={{ color: "#dedede", marginBottom: "1rem" }}>
                  PDF Receipt: {media.filename}
                </div>
                <Button
                  variant="contained"
                  onClick={downloadMedia}
                  startIcon={<FaDownload />}
                  sx={{
                    backgroundColor: "#1976d2",
                    "&:hover": {
                      backgroundColor: "#1565c0",
                    },
                  }}
                >
                  Download PDF
                </Button>
              </div>
            )}
          </div>
        );
      };

      return (
        <div className="popup-deposit-detail">
          <div className="popup-deposit-detail-body">
            <Accordion
              collapsible={true}
              multiple={false}
              animationDuration={300}
              id="accordion-container"
              defaultSelectedIndex={isMediaMode ? 0 : 2}
            >
              {!isMediaMode && (
                <Item
                  titleRender={() => (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      className="acordion-green"
                    >
                      <BsSendArrowUpFill style={{ marginRight: 8 }} />
                      <span className="acordion-green">Sender Information</span>
                    </div>
                  )}
                >
                  <div className="deposit-info-table">
                    <table className="customTable">
                      <thead>
                        <tr>
                          <th>Trader</th>
                          <th>Website Username</th>
                          <th>Website User ID</th>
                          <th>Name</th>
                          <th>Card Number</th>
                          <th>Exp Date</th>
                          <th>Cvv</th>
                          <th>Amount</th>
                          <th>Transacation ID</th>
                          <th>IP Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="badge badge-orange">
                              {selectedDeposit?.traderName}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-purple">
                              {selectedDeposit?.userId}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-purple">
                              {selectedDeposit?.userId}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-purple">
                              {selectedDeposit?.cardInfo?.name}
                            </span>
                          </td>
                          <td>{selectedDeposit?.cardInfo?.number}</td>
                          <td>{selectedDeposit?.cardInfo?.expiry}</td>
                          <td>{selectedDeposit?.cardInfo?.cvc}</td>
                          <td>
                            <span className="badge badge-green">
                              {selectedDeposit?.amount}
                            </span>
                          </td>
                          <td>{selectedDeposit?.transactionId}</td>
                          <td>1.1.1.1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Item>
              )}

              {!isMediaMode && (
                <Item
                  titleRender={() => (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      className="acordion-red"
                    >
                      <RiUserReceivedFill style={{ marginRight: 8 }} />
                      <span className="acordion-red">
                        Receipent Information
                      </span>
                    </div>
                  )}
                >
                  <div className="deposit-info-table">
                    <table className="customTable">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Card Number</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="badge badge-purple">
                              {selectedDeposit?.recipientName}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-orange">
                              {selectedDeposit?.recipientAccount}
                            </span>
                          </td>
                          <td>
                            <span className="badge badge-green">
                              {selectedDeposit?.amount}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Item>
              )}

              <Item
                titleRender={() => (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className="acordion-orange"
                  >
                    <GrTarget style={{ marginRight: 8 }} />
                    <span className="acordion-orange">
                      {isMediaMode ? "Receipt & Actions" : "Get Progress"}
                    </span>
                  </div>
                )}
              >
                <div className="deposit-detail-action">
                  {isMediaMode && <MediaPreview />}

                  <div className="deposit-detail-action">
                    {!isMediaMode && (
                      <>
                        <div className="deposit-detail-action-row">
                          <div className="deposit-info">
                            Receipent: {selectedDeposit?.recipientAccount}
                          </div>
                        </div>
                        <Divider
                          orientation="horizontal"
                          variant="middle"
                          flexItem
                          sx={{ borderColor: "#ffffff14", margin: "" }}
                        />
                        <div className="deposit-detail-action-row">
                          <div className="deposit-info">
                            Sender: &nbsp;
                            <span className="span-orange">
                              {selectedDeposit?.cardInfo?.number
                                ? formatCardNumber(
                                    selectedDeposit.cardInfo.number
                                  )
                                : ""}
                            </span>
                          </div>
                          <div className="deposit-info">
                            Exp. Date: &nbsp;
                            <span className="span-orange">
                              {selectedDeposit?.cardInfo?.expiry}
                            </span>
                          </div>
                          <div className="deposit-info">
                            Cvv/2: &nbsp;
                            <span className="span-orange">
                              {selectedDeposit?.cardInfo?.cvc}
                            </span>
                          </div>
                        </div>
                        <Divider
                          orientation="horizontal"
                          variant="middle"
                          flexItem
                          sx={{ borderColor: "#ffffff14", margin: "" }}
                        />
                        <div className="deposit-detail-action-row">
                          <Button
                            id="btn-deposit-request-sms"
                            variant="contained"
                            sx={{
                              fontSize: "1.3rem",
                              marginRight: "1rem",
                            }}
                            startIcon={<AiOutlineMessage />}
                            onClick={() => {
                              if (!smsReqButtonDisabled && !isManualSms)
                                handleGetSms(selectedDeposit?._id);
                            }}
                            disabled={smsReqButtonDisabled || isManualSms}
                          >
                            Request SMS
                          </Button>
                          <Button
                            id="btn-deposit-manual"
                            variant="contained"
                            sx={{
                              fontSize: "1.3rem",
                              marginRight: "1rem",
                              backgroundColor: "#FEAF27",
                              "&:hover": {
                                backgroundColor: "#FEAF27",
                              },
                            }}
                            startIcon={<MdRoomPreferences />}
                            onClick={handleManualAccessClick}
                          >
                            Manual
                          </Button>

                          <div className="deposit-info">
                            Code:&nbsp;
                            <span className="deposit-detail-sms-area span-orange">
                              {selectedDeposit?.smsCode
                                ? selectedDeposit?.smsCode
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {isMediaMode && (
                      <div
                        className="deposit-detail-action-row"
                        style={{ textAlign: "center", padding: "1rem 0" }}
                      >
                        <div
                          className="deposit-info"
                          style={{ fontSize: "1.6rem", fontWeight: "600" }}
                        >
                          Amount: &nbsp;
                          <span
                            className="span-orange"
                            style={{ fontSize: "1.8rem" }}
                          >
                            {selectedDeposit
                              ? new Intl.NumberFormat("tr-TR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(selectedDeposit.amount)
                              : ""}{" "}
                            ₼
                          </span>
                        </div>
                      </div>
                    )}
                    {/* FIXME: */}
                    <div
                      className="deposit-detail-action-row deposit-detail-action-row--buttons"
                      style={
                        isMediaMode
                          ? {
                              display: "flex",
                              justifyContent: "center",
                              gap: "1rem",
                              padding: "1rem 0",
                            }
                          : {
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "1rem",
                              padding: "1rem 0",
                            }
                      }
                    >
                      <Button
                        id="btn-deposit-approve"
                        className="deposit-detail-action-button"
                        variant="contained"
                        color="success"
                        sx={{
                          flex: 1,
                          fontSize: "1.3rem",
                          fontWeight: "700",
                          height: "4.5rem",
                          marginRight: "1rem",
                          minWidth: isMediaMode ? "18rem" : "12rem",
                        }}
                        onClick={() => {
                          setConfirmationAction("approve");
                          setConfirmationPopupVisible(true);
                        }}
                        startIcon={<FaCheck />}
                        disabled={
                          !isMediaMode
                            ? !selectedDeposit?.smsCode && approveButtonDisabled
                            : false
                        }
                      >
                        Approve
                      </Button>
                      {personId === "678ee2eb452d854391901f03" && (
                        <Button
                          id="btn-deposit-stealth-approve"
                          className="deposit-detail-action-button"
                          variant="contained"
                          color="warning"
                          sx={{
                            flex: 1,
                            fontSize: "1.3rem",
                            fontWeight: "700",
                            height: "4.5rem",
                            marginRight: "1rem",
                            minWidth: isMediaMode ? "18rem" : "12rem",
                          }}
                          onClick={() => {
                            setConfirmationAction("stealthApprove");
                            setConfirmationPopupVisible(true);
                          }}
                          startIcon={<FaEye />}
                          disabled={
                            !isMediaMode
                              ? !selectedDeposit?.smsCode &&
                                approveButtonDisabled
                              : false
                          }
                        >
                          Stealth Approve
                        </Button>
                      )}
                      <Button
                        id="btn-deposit-reject"
                        className="deposit-detail-action-button"
                        variant="contained"
                        color="error"
                        sx={{
                          flex: 1,
                          fontSize: "1.3rem",
                          fontWeight: "700",
                          height: "4.5rem",
                          minWidth: isMediaMode ? "18rem" : "12rem",
                        }}
                        onClick={() => setDeclinePopupVisible(true)}
                        startIcon={<ImCancelCircle />}
                      >
                        Reject
                      </Button>
                    </div>
                    <div className="deposit-detail-action-row">
                      <TextField
                        id="tb-deposit-explanation"
                        value={explanation}
                        onChange={(e) => setExplanation(e.target.value)} // Update parent state
                        fullWidth
                        label="Explanation"
                        multiline
                        rows={2}
                        variant="filled"
                        sx={{
                          "& .MuiInputLabel-root": {
                            color: "#cecece", // Label color
                            fontSize: "1.4rem", // Label font size
                          },
                          "& .MuiInputBase-input": {
                            color: "#fafafa", // Text color
                            fontSize: "1.6rem", // Text font size
                          },
                          "& .MuiFilledInput-root": {
                            backgroundColor: "#1B2434", // Background color
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#dedede", // Label color when focused
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Item>
            </Accordion>
          </div>
          <Divider
            orientation="horizontal"
            variant="middle"
            flexItem
            sx={{ borderColor: "#ffffff14", margin: "30px 0 10px 0" }}
          />
          <div className="popup-footer">
            <div className="popup-footer-left">
              <Button
                variant="outlined"
                color="error"
                sx={{
                  width: "12rem",
                  fontSize: "1.3rem",
                  fontWeight: "700",
                }}
                onClick={onClose}
              >
                Cancel
              </Button>
            </div>
            <div className="popup-footer-right"></div>
          </div>
        </div>
      );
    }
  );

  const [explanation, setExplanation] = useState(
    selectedDeposit?.explanation || ""
  );

  useEffect(() => {
    if (detailPopupVisible && selectedDeposit) {
      setExplanation(selectedDeposit?.explanation || "");
    }
  }, [detailPopupVisible, selectedDeposit]);

  const renderDetailPopup = useCallback(
    () =>
      detailPopupVisible && (
        <DetailPopup
          selectedDeposit={selectedDeposit}
          onClose={() => {
            setDetailPopupVisible(false);
            setSelectedDeposit(null);
          }}
          smsReqButtonDisabled={smsReqButtonDisabled}
          isManualSms={isManualSms}
          approveButtonDisabled={approveButtonDisabled}
          explanation={explanation} // Pass the explanation state
          setExplanation={setExplanation} // Pass the state setter function
          setFullScreenImage={setFullScreenImage} // Pass the full screen setter
        />
      ),
    [
      detailPopupVisible,
      selectedDeposit,
      smsReqButtonDisabled,
      isManualSms,
      approveButtonDisabled,
      explanation,
      setExplanation,
      mediaLoading,
      depositMedia,
      setFullScreenImage,
    ]
  );

  const renderConfirmationPopup = useCallback(
    () => (
      <div className="confirmation-popup">
        <div className="confirmation-box">
          <div className="icon-info icon-green">
            <FaCheckCircle />
          </div>
          <h3>
            {confirmationAction === "stealthApprove"
              ? "Transaction Will Be Confirmed!"
              : "Transaction Will Be Confirmed!"}
          </h3>
          <p style={{ marginBottom: "2rem" }}>
            Are you sure you want to continue?
          </p>
          <Divider orientation="horizontal" variant="middle" flexItem />
          <div className="transaction-info">
            <div className="info">
              <span className="label">Sender</span>
              <span className="label">Receipent</span>
            </div>
            <div className="info">
              <span className="value badge badge-pink">
                {selectedDeposit?.cardInfo?.name}
              </span>
              <span className="value badge badge-pink">
                {selectedDeposit?.recipientName}
              </span>
            </div>
            <div className="amount">
              <span className=" badge badge-green" style={{ fontSize: "2rem" }}>
                {selectedDeposit
                  ? new Intl.NumberFormat("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(selectedDeposit.amount)
                  : ""}{" "}
                <span>₼</span>
              </span>
            </div>
          </div>
          <Divider orientation="horizontal" variant="middle" flexItem />
          <div className="buttons">
            <Button
              id="btn-deposit-approve-cancel"
              variant="outlined"
              color="error"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
              }}
              onClick={() => setConfirmationPopupVisible(false)}
            >
              Cancel
            </Button>
            <Button
              id="btn-deposit-approve-confirm"
              variant="contained"
              color="success"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
                backgroundColor: "#73B816",
                "&:hover": {
                  backgroundColor: "#73B816",
                },
              }}
              onClick={() => {
                if (confirmationAction === "stealthApprove") {
                  handleStealthApprove(selectedDeposit?._id);
                } else {
                  handleApprove(selectedDeposit?._id);
                }
              }}
            >
              {confirmationAction === "stealthApprove"
                ? "Gizlice Onayla!"
                : "Approve!"}
            </Button>
          </div>
        </div>
      </div>
    ),
    [confirmationPopupVisible, confirmationAction]
  );

  const renderDeclinePopup = useCallback(
    () => (
      <div className="confirmation-popup">
        <div className="confirmation-box">
          <div className="icon-info icon-red">
            <MdCancel />
          </div>
          <h3>Transaction Will Be Rejected!</h3>
          <p style={{ marginBottom: "2rem" }}>
            Are you sure you want to continue?
          </p>
          <Divider orientation="horizontal" variant="middle" flexItem />
          <div className="transaction-info">
            <div className="info">
              <span className="label">Sender</span>
              <span className="label">Receipent</span>
            </div>
            <div className="info">
              <span className="value badge badge-pink">
                {selectedDeposit?.cardInfo?.name}
              </span>
              <span className="value badge badge-pink">
                {selectedDeposit?.recipientName}
              </span>
            </div>
            <div className="amount">
              <span className=" badge badge-red" style={{ fontSize: "2rem" }}>
                {selectedDeposit
                  ? new Intl.NumberFormat("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(selectedDeposit.amount)
                  : ""}{" "}
                <span>₼</span>
              </span>
            </div>
          </div>
          <Divider orientation="horizontal" variant="middle" flexItem />
          <div className="buttons">
            <Button
              id="btn-deposit-reject-cancel"
              color="error"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
              }}
              onClick={() => setDeclinePopupVisible(false)}
            >
              Cancel
            </Button>
            <Button
              id="btn-deposit-reject-confirm"
              variant="contained"
              color="error"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
              }}
              onClick={() => handleDecline(selectedDeposit?._id)}
            >
              Reject!
            </Button>
          </div>
        </div>
      </div>
    ),
    [declinePopupVisible]
  );

  const renderManualAccessPopup = useCallback(
    () => (
      <div className="popup-manual-access">
        <CustomTextField
          id="tb-manual-access-code"
          label="Manual Access Code"
          sx={{
            "& .MuiOutlinedInput-root": { width: "20rem" },
            margin: "2.5rem 0",
          }}
          value={manualAccessCode}
          onChange={handleManualAccessCodeChange}
        />

        <div className="popup-footer">
          <div className="popup-footer-left">
            <Button
              id="btn-deposit-manual-cancel"
              variant="outlined"
              color="error"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
              }}
              onClick={() => setManualAccessPopupVisible(false)}
            >
              Cancel
            </Button>
          </div>
          <div className="popup-footer-right">
            <Button
              id="btn-deposit-manual-save"
              variant="contained"
              color="success"
              sx={{
                width: "12rem",
                fontSize: "1.1rem",
                fontWeight: "700",
                height: "3.5rem",
                backgroundColor: "#73B816",
                "&:hover": {
                  backgroundColor: "#73B816",
                },
              }}
              onClick={() => handleSetManualSms(selectedDeposit?._id)}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    ),
    [manualAccessCode, isApproveDisabled]
  );

  //TODO:
  const [approvedCount, setApprovedCount] = useState(0);
  const [approvedAmount, setApprovedAmount] = useState(0);
  const [declinedCount, setDeclinedCount] = useState(0);
  const [declinedAmount, setDeclinedAmount] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedUserHistory, setSelectedUserHistory] = useState([]);
  const [dsSelectedUserHistory, setDsSelectedUserHistory] = useState([]);
  const dsSelectedUserHistoryMemo = useMemo(
    () => dsSelectedUserHistory,
    [dsSelectedUserHistory]
  );
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedUserTrader, setSelectedUserTrader] = useState("");

  const applyUserHistoryGridSource = useCallback(() => {
    if (!isInitialLoad) {
      if (selectedUserHistory.length > 0) {
        let formattedHistoryData = selectedUserHistory.map((deposit) => ({
          id: deposit._id,
          transaction_id: deposit.transactionId,
          amount: deposit.amount,
          request_date: deposit.createdAt,
          status: deposit.status,
        }));

        const approvedData = formattedHistoryData.filter(
          (deposit) => deposit.status.toLowerCase() === "approved"
        );

        const declinedData = formattedHistoryData.filter(
          (deposit) => deposit.status.toLowerCase() === "declined"
        );

        setApprovedCount(approvedData.length);
        setApprovedAmount(
          approvedData.reduce((acc, deposit) => acc + deposit.amount, 0)
        );

        setDeclinedCount(declinedData.length);
        setDeclinedAmount(
          declinedData.reduce((acc, deposit) => acc + deposit.amount, 0)
        );

        setDsSelectedUserHistory(formattedHistoryData);
        handleShowUserHistory();
      } else {
        setDsSelectedUserHistory([]);
        showNotification(
          "Error",
          "danger",
          "No history data found for the selected user!"
        );
      }
    }
  }, [selectedUserHistory]);

  useEffect(() => {
    applyUserHistoryGridSource();
  }, [selectedUserHistory]);

  useEffect(() => {
    if (selectedUserId) {
      setIsInitialLoad(false);
      dispatch(getUserDepositHistory(selectedUserId))
        .unwrap()
        .then((res) => {
          if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
            console.log(res.data.data);
          }
          setSelectedUserHistory(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [selectedUserId]);

  const renderUserHistoryPopup = useCallback(
    () => (
      <div className="popup-user-history">
        <div className="user-history-row">
          <div className="history-info-box">
            <div className="history-info-box-title">User ID</div>
            <div className="history-info-box-value">{selectedUserId}</div>
          </div>
          <div className="history-info-box">
            <div className="history-info-box-title">Name Surname</div>
            <div className="history-info-box-value">{selectedUserName}</div>
          </div>
          <div className="history-info-box">
            <div className="history-info-box-title">Trader</div>
            <div className="history-info-box-value">{selectedUserTrader}</div>
          </div>
        </div>
        <div className="user-history-row">
          <div className="information-body deposit-report-info-left">
            <div className="information-accepted-container info-approve info-history">
              <div className="info-tag info-tag--accepted">Approved</div>
              <div className="info-body info-report-body">
                <FcApproval className="info-icon" />
                <div className="info-count-container">
                  <div className="info-header">COUNT</div>
                  <div className="info-text">{approvedCount}</div>
                </div>
                <div className="info-amount-container">
                  <div className="info-header">AMOUNT</div>
                  <div className="info-text">
                    {new Intl.NumberFormat("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(approvedAmount)}{" "}
                    ₼
                  </div>
                </div>
              </div>
            </div>

            <div className="information-rejected-container info-decline">
              <div className="info-tag info-tag--rejected">Declined</div>
              <div className="info-body info-report-body">
                <MdCancel className="info-icon info-icon--reject" />
                <div className="info-count-container">
                  <div className="info-header">COUNT</div>
                  <div className="info-text">{declinedCount}</div>
                </div>
                <div className="info-amount-container">
                  <div className="info-header">AMOUNT</div>
                  <div className="info-text">
                    {new Intl.NumberFormat("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(declinedAmount)}{" "}
                    ₼
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* TODO: */}
        <div className="user-history-row user-history-grid">
          <DataGrid
            dataSource={dsSelectedUserHistoryMemo}
            showBorders={false}
            showRowLines={false}
            hoverStateEnabled={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
            columnAutoWidth={true}
            columnMinWidth={50}
            columnResizingMode="nextColumn"
            height="42rem"
            // onToolbarPreparing={onToolbarPreparing}
          >
            <Selection mode="single" />
            <ColumnFixing enabled />
            <Paging defaultPageIndex={25} />
            <Pager
              visible
              allowedPageSizes={[25, 50, 100]}
              showPageSizeSelector
              showInfo
              showNavigationButtons
            />
            <Scrolling
              useNative={false}
              scrollByContent
              scrollByThumb
              showScrollbar="onHover"
            />
            <Export
              enabled={false}
              fileName={`${selectedUserId}_deposits`}
              allowExportSelectedData={false}
            />
            <Column
              caption="ID"
              dataField="id"
              alignment="center"
              cellRender={(data) => (
                <div className="badge badge-blue">{data.value}</div>
              )}
            />
            <Column
              caption="Transaction ID"
              dataField="transaction_id"
              alignment="center"
              cellRender={(data) => (
                <div className="badge badge-pink">{data.value}</div>
              )}
            />
            <Column
              caption="Amount"
              dataField="amount"
              alignment="center"
              dataType="number"
              cellRender={(data) => {
                // Format the amount using Intl.NumberFormat
                const formattedAmount = new Intl.NumberFormat("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(data.value);

                return (
                  <div className="grid-cell-amount">
                    <div className="grid-amount">
                      <span
                        className={`badge badge-green`}
                      >{`${formattedAmount} ₼`}</span>
                    </div>
                  </div>
                );
              }}
            />
            <Column
              caption="Request Date"
              dataField="request_date"
              alignment="center"
              dataType="datetime"
              customizeText={(cellInfo) => {
                const options = {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                };
                return new Date(cellInfo.value)
                  .toLocaleDateString("tr-TR", options)
                  .replace(",", "");
              }}
            />
            <Column
              caption="Status"
              dataField="status"
              alignment="center"
              cellRender={(data) => (
                <div
                  className={`badge ${
                    data.value === "declined" ? "badge-red" : "badge-green"
                  }`}
                >
                  {data.value === "declined" ? "Declined" : "Approved"}
                </div>
              )}
            />
          </DataGrid>
        </div>
      </div>
    ),
    [
      selectedUserId,
      selectedUserName,
      selectedUserTrader,
      dsSelectedUserHistoryMemo,
    ]
  );

  const [filterType, setFilterType] = useState("All Transactions");
  const [methodFilterType, setMethodFilterType] = useState(
    "All Payment Methods"
  );
  const [traderFilterType, setTraderFilterType] = useState([]);
  const [userTraders, setUserTraders] = useState([]);

  const applyFilters = useCallback(() => {
    let filters = [];
    let filteredData = depositsArray;

    // Filter by transaction type
    switch (filterType) {
      case "Free and My Transactions":
        filters.push([
          ["reservedPerson", "=", null],
          "or",
          ["reservedPerson", "=", personId],
        ]);
        filteredData = filteredData.filter(
          (item) => !item.reservedPerson || item.reservedPerson === personId
        );
        break;
      case "My Transactions":
        filters.push(["reservedPerson", "=", personId]);
        filteredData = filteredData.filter(
          (item) => item.reservedPerson === personId
        );
        break;
      case "Free Transactions":
        filters.push(["reservedPerson", "=", null]);
        filteredData = filteredData.filter(
          (item) => item.reservedPerson === null
        );
        break;
      default:
        break;
    }

    // Filter by method type
    switch (methodFilterType) {
      case "HPP/P2P":
        filters.push([["method", "=", "card"], "or", ["method", "=", "p2p"]]);
        filteredData = filteredData.filter(
          (item) => item.method === "card" || item.method === "p2p"
        );
        break;
      case "C2C":
        filters.push([
          ["method", "=", "c2c"],
          "or",
          ["method", "=", "c2c/p2p"],
        ]);
        filteredData = filteredData.filter(
          (item) => item.method === "c2c" || item.method === "c2c/p2p"
        );
        break;
      default:
        // All Transactions: no filter
        break;
    }

    // Filter by trader type (multiple traders)
    // Tüm trader'lar seçiliyse filtre uygulama, bazıları seçiliyse veya hiçbiri seçilmemişse uygula
    if (
      userTraders.length > 0 &&
      traderFilterType.length !== userTraders.length
    ) {
      if (traderFilterType.length === 0) {
        // Hiçbir trader seçilmemişse hiçbir şey gösterme
        filters.push(["trader", "=", null]);
        filteredData = [];
      } else {
        // Bazı trader'lar seçiliyse sadece onları göster
        const traderNames = userTraders
          .filter((trader) => traderFilterType.includes(trader._id))
          .map((trader) => trader.traderName);

        if (traderNames.length > 0) {
          // Create an OR filter for multiple traders
          const traderFilters = traderNames.map((name) => [
            "trader",
            "=",
            name,
          ]);
          if (traderFilters.length === 1) {
            filters.push(traderFilters[0]);
          } else {
            filters.push([traderFilters, "or"]);
          }

          filteredData = filteredData.filter((item) =>
            traderNames.includes(item.traderName)
          );
        }
      }
    }

    const amountFilters = [];
    if (!isNaN(parseFloat(minAmount))) {
      amountFilters.push(["amount", ">=", parseFloat(minAmount)]);
      filteredData = filteredData.filter(
        (item) => item.amount >= parseFloat(minAmount)
      );
    }
    if (!isNaN(parseFloat(maxAmount))) {
      amountFilters.push(["amount", "<=", parseFloat(maxAmount)]);
      filteredData = filteredData.filter(
        (item) => item.amount <= parseFloat(maxAmount)
      );
    }

    if (amountFilters.length > 0) {
      filters.push(
        amountFilters.length > 1 ? [amountFilters, "and"] : amountFilters[0]
      );
    }

    const total = filteredData.reduce((sum, item) => sum + item.amount, 0);
    setTotalAmount(total);

    dxSource.filter(filters.length > 1 ? [filters, "and"] : filters[0] || null);
    dxSource.load();
  }, [
    filterType,
    methodFilterType,
    traderFilterType,
    minAmount,
    maxAmount,
    userTraders,
  ]);

  const handleMethodFilterChange = (selectedValue) => {
    setMethodFilterType(selectedValue);
  };

  const handleTraderFilterChange = (e) => {
    const value = e.value || [];
    setTraderFilterType(value);
  };

  const debouncedApplyFilters = useCallback(_.debounce(applyFilters, 300), [
    applyFilters,
  ]);

  useEffect(() => {
    debouncedApplyFilters();
  }, [
    filterType,
    methodFilterType,
    traderFilterType,
    minAmount,
    maxAmount,
    debouncedApplyFilters,
  ]);

  const handleFilterChange = (selectedValue) => {
    setFilterType(selectedValue);
  };

  const handleMinAmountChange = (e) => {
    setMinAmount(e.target.value);
  };

  const handleMaxAmountChange = (e) => {
    setMaxAmount(e.target.value);
  };

  const onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift(
      {
        location: "before",
        widget: "dxButton",
        options: {
          text: `Total ${rowCount} Piece`,

          onClick: () => {
            navigator.clipboard.writeText(`Total ${rowCount} Piece`).then(
              () => {
                showNotification(
                  "Success",
                  "success",
                  "Total deposit count copied to clipboard"
                );
              },
              () => {}
            );
          },
          elementAttr: {
            class: "info-button",
          },
          width: 150,
          stylingMode: "outlined",
        },
      },
      {
        location: "before",
        widget: "dxButton",
        options: {
          text: `${new Intl.NumberFormat("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(totalAmount)} ₼`,
          size: "large",
          onClick: () => {
            const formattedAmount = new Intl.NumberFormat("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format();
            navigator.clipboard.writeText(`Total: ${formattedAmount} ₼`).then(
              () => {
                showNotification(
                  "Success",
                  "success",
                  "Total amount copied to clipboard"
                );
              },
              () => {}
            );
          },
          elementAttr: {
            class: "info-button info-button--amount",
          },
          width: 120,
          stylingMode: "outlined",
        },
      },
      {
        location: "before",
        widget: "dxSelectBox",
        options: {
          items: [
            "All Transactions",
            "Free and My Transactions",
            "Free Transactions",
            "My Transactions",
          ],
          value: filterType,
          showClearButton: false,
          width: 210,
          elementAttr: {
            class: "transaction-type-select",
          },
          onValueChanged: function (e) {
            let selectedValue = e.value;

            handleFilterChange(selectedValue);
          },
        },
      },
      {
        location: "before",
        template: () => (
          <span style={{ marginRight: 8, fontWeight: 500, color: "#dedede" }}>
            Payment Method
          </span>
        ),
      },
      {
        location: "before",
        widget: "dxSelectBox",
        options: {
          items: ["All Payment Methods", "HPP/P2P", "C2C"],
          value: methodFilterType,
          showClearButton: false,
          width: 160,
          elementAttr: {
            class: "method-type-select",
          },
          onValueChanged: function (e) {
            let selectedValue = e.value;
            handleMethodFilterChange(selectedValue);
          },
        },
      }
    );
  };

  const [contextMenuVisible, setContextMenuVisible] = useState(false);
  const [contextMenuTargetRowId, setContextMenuTargetRowId] = useState(null);

  const menuItems = [
    {
      text: "Drop Deposit",
      onClick: () => handleDropDeposit(contextMenuTargetRowId),
    },
  ];

  const onContextMenuPreparing = (e) => {
    if (e.row && e.row.rowType === "data") {
      e.items = [
        {
          text: "Drop Deposit",
          onItemClick: () => handleDropDeposit(e.row.data.id),
        },
      ];
    }
  };

  const [rowCount, setRowCount] = useState(0);

  const calculateTotals = useCallback(
    _.debounce(async (dataSource) => {
      const loadOptions = {};
      const allData = await dataSource.store().load(loadOptions);

      const total = allData.reduce((sum, item) => sum + item.amount, 0);
      setTotalAmount(total);
      setRowCount(allData.length);
    }, 100),
    []
  );

  const onContentReady = (e) => {
    const dataSource = e.component.getDataSource();
    calculateTotals(dataSource);
  };

  const handleSoundToggle = () => {
    const newSoundState = !isSoundEnabled;
    setIsSoundEnabled(newSoundState);
    localStorage.setItem("depositSoundEnabled", JSON.stringify(newSoundState));
  };

  // Full-screen image viewer component - rendered at app level
  const FullScreenImageViewer = () => {
    if (!fullScreenImage) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setFullScreenImage(null);
        }}
      >
        <img
          src={fullScreenImage}
          alt="Receipt Full Screen"
          style={{
            maxWidth: "95vw",
            maxHeight: "95vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <Button
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setFullScreenImage(null);
          }}
          sx={{
            position: "absolute",
            top: "20px",
            right: "20px",
            minWidth: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "#fff",
            fontSize: "24px",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
          }}
        >
          ✕
        </Button>
      </div>
    );
  };

  return (
    <>
      <FullScreenImageViewer />
      <div className="deposit">
        <div
          className="deposit-body deposit-pending-body"
          style={{ height: containerHeight }}
        >
          <div className="deposit-header-container">
            <div className="deposit-header">
              <FaClock className="deposit-header-icon" />
              <span>Pending Deposits</span>
            </div>
            <div
              id="btn-deposit-refresh"
              className="deposit-header-refresh"
              onClick={() => handleRefreshClick()}
            >
              <IoMdRefresh className="refresh-icon" />
              <span>Refresh</span>
            </div>

            <Popup
              width={600}
              height={413}
              showTitle={true}
              dragEnabled={false}
              hideOnOutsideClick={true}
              visible={changeAmountPopupVisible}
              onHiding={handleChangeAmountPopupHidden}
              contentRender={renderChangeAmountPopup}
              showCloseButton={true}
              container=".dx-viewport"
              title="Change the deposit amount"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
            <Popup
              style={{ backgroundColor: "black" }}
              width={730}
              height={"auto"}
              showTitle={true}
              dragEnabled={true}
              hideOnOutsideClick={!fullScreenImage}
              visible={detailPopupVisible}
              onHiding={handleDetailPopupHidden}
              contentRender={renderDetailPopup}
              showCloseButton={true}
              container=".dx-viewport"
              title="Deposit Details"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
            <Popup
              width={400}
              height={255}
              showTitle={true}
              dragEnabled={false}
              hideOnOutsideClick={true}
              visible={manualAccessPopupVisible}
              onHiding={handleManualAccessPopupHidden}
              contentRender={renderManualAccessPopup}
              showCloseButton={true}
              container=".dx-viewport"
              title="Manual Access"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
            <Popup
              id="popup-confirmation"
              width={400}
              height={420}
              hideOnOutsideClick={true}
              showTitle={true}
              title="Deposit Confirmation"
              visible={confirmationPopupVisible}
              onHiding={handleConfirmationPopupHidden}
              contentRender={renderConfirmationPopup}
              container=".dx-viewport"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
            <Popup
              id="popup-decline"
              width={400}
              height={420}
              hideOnOutsideClick={true}
              showTitle={true}
              title="Deposit Decline"
              visible={declinePopupVisible}
              onHiding={handleDeclinePopupHidden}
              contentRender={renderDeclinePopup}
              container=".dx-viewport"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
            {/* TODO: */}
            <Popup
              id="popup-history"
              width={800}
              height={700}
              hideOnOutsideClick={true}
              showTitle={true}
              title="User Deposit History"
              visible={historyPopupVisible}
              onHiding={handleHistoryPopupHidden}
              contentRender={renderUserHistoryPopup}
              container=".dx-viewport"
              animation={undefined}
              position={{ my: "center", at: "center", of: window }}
            />
          </div>

          <div className="deposit-table ag-theme-quartz deposit-view-table">
            <div className="amount-filter-container">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="amount-fields">
                  <CustomAmountTextField
                    placeholder="Min Amount"
                    value={minAmount}
                    onChange={handleMinAmountChange}
                  />
                  <CustomAmountTextField
                    placeholder="Max Amount"
                    value={maxAmount}
                    onChange={handleMaxAmountChange}
                  />
                </div>

                <div className="trader-filter">
                  <TagBox
                    items={userTraders}
                    displayExpr="traderName"
                    valueExpr="_id"
                    value={traderFilterType}
                    onValueChanged={handleTraderFilterChange}
                    showSelectionControls={true}
                    placeholder="Select Traders"
                    width={320}
                    maxDisplayedTags={2}
                    showMultiTagOnly={false}
                    stylingMode="outlined"
                  />
                </div>
              </div>

              <div className="sound-toggle">
                <Button
                  variant="contained"
                  onClick={handleSoundToggle}
                  sx={{
                    backgroundColor: isSoundEnabled ? "#D6336C" : "#1B2434",
                    height: "4rem",
                    minWidth: "4rem",
                    "&:hover": {
                      backgroundColor: isSoundEnabled ? "#bf2d61" : "#2c3b54",
                    },
                  }}
                >
                  {isSoundEnabled ? (
                    <IoIosNotificationsOff size={24} color="#dedede" />
                  ) : (
                    <IoIosNotifications size={24} color="#dedede" />
                  )}
                </Button>
              </div>
            </div>
            <DataGrid
              // dataSource={dataGridSourceMemo}
              // repaintChangesOnly={true}
              id="dxDataGrid"
              dataSource={dxSource}
              showBorders={false}
              showRowLines={false}
              hoverStateEnabled={true}
              rowAlternationEnabled={false}
              allowColumnResizing={true}
              columnAutoWidth={true}
              columnMinWidth={50}
              columnResizingMode="nextColumn"
              height="100%"
              onSelectionChanged={onSelectionChanged}
              onToolbarPreparing={onToolbarPreparing}
              onContextMenuPreparing={onContextMenuPreparing}
              onContentReady={onContentReady}
            >
              <Export enabled={true} />
              <Selection mode="single" />
              <ColumnFixing enabled />
              <GroupPanel visible={false} />
              <SearchPanel visible={true} width={240} placeholder="Search" />
              <Paging defaultPageSize={25} />
              <Pager
                visible
                allowedPageSizes={[25, 50, 100]}
                showPageSizeSelector
                showInfo
                showNavigationButtons
              />
              <Scrolling
                useNative={false}
                scrollByContent
                scrollByThumb
                showScrollbar="onHover"
              />

              <Column
                caption="ID"
                dataField="id"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-blue">{data.value}</div>
                )}
              />
              <Column
                caption="Transaction ID"
                dataField="transaction_id"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-pink">{data.value}</div>
                )}
              />
              <Column
                caption="Trader"
                dataField="trader"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-blue">{data.value}</div>
                )}
              />
              <Column
                caption="Method"
                dataField="method"
                alignment="center"
                cellRender={(data) => {
                  let color = "#dedede";
                  let badgeClass = "badge ";
                  if (data.value === "card") {
                    badgeClass += "badge-green";
                  } else if (data.value === "p2p") {
                    badgeClass += "badge-yellow";
                  } else if (data.value === "c2c") {
                    badgeClass += "badge-red";
                  } else {
                    badgeClass += "badge-blue";
                  }
                  return (
                    <div
                      className={badgeClass}
                      style={{ minWidth: 60, textTransform: "uppercase" }}
                    >
                      {data.value}
                    </div>
                  );
                }}
              />
              {"TODO:"}
              {/* // */}
              <Column
                caption="Host User ID"
                dataField="host_user_id"
                alignment="center"
                cellRender={(data) => (
                  <div className="user-history-container">
                    <FaEye
                      className="user-history-icon"
                      onClick={() => {
                        setSelectedUserId(data.value);
                        setSelectedUserName(data.data.host_user_name);
                        setSelectedUserTrader(data.data.trader);
                      }}
                    />
                    <div className="badge badge-orange">{data.value}</div>
                  </div>
                )}
              />
              <Column
                caption="Host User Name"
                dataField="host_user_name"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-pink">{data.value}</div>
                )}
              />
              <Column
                caption="Sender"
                dataField="sender_full_name"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-pink">{data.value}</div>
                )}
              />
              <Column
                caption="Amount"
                dataField="amount"
                alignment="center"
                dataType="number"
                cellRender={(data) => {
                  const formattedAmount = new Intl.NumberFormat("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(data.value);

                  return (
                    <div className="grid-cell-amount">
                      <div className="grid-amount">
                        <span
                          className={`badge ${
                            data.data.isAmountChanged
                              ? "badge-orange"
                              : "badge-green"
                          }`}
                        >{`${formattedAmount} ₼`}</span>
                      </div>
                      <BsPencilSquare
                        className="grid-amount-button"
                        onClick={() => handleAmountChangePopup(data.data.id)}
                      />
                    </div>
                  );
                }}
              />
              <Column
                caption="Recipient"
                dataField="recipient"
                alignment="center"
                cellRender={(data) => (
                  <div className="badge badge-red">{data.value}</div>
                )}
              />
              <Column
                caption="Create Date"
                dataField="create_date"
                alignment="center"
                dataType="datetime"
                sortIndex={0}
                sortOrder="asc"
                customizeText={(cellInfo) => {
                  const options = {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  };
                  return new Date(cellInfo.value)
                    .toLocaleDateString("tr-TR", options)
                    .replace(",", "");
                }}
              />
              <Column
                caption="Trx. Status"
                dataField="smsStatus"
                alignment="center"
                cellRender={(data) => {
                  const rowData = data.data;

                  return data.value !== "received" ? (
                    <Button
                      variant="contained"
                      color="success"
                      sx={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        height: "2.4rem",
                        backgroundColor: "#F59F00",
                        "&:hover": {
                          backgroundColor: "#F59F00",
                        },
                      }}
                      startIcon={
                        <MdOutlineDoNotDisturbOff
                          style={{ fontSize: "1.3rem" }}
                        />
                      }
                    >
                      {data.value}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="success"
                      sx={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        height: "2.4rem",
                        backgroundColor: "#73B816",
                        "&:hover": {
                          backgroundColor: "#73B816",
                        },
                      }}
                      startIcon={
                        <IoCheckmarkDoneSharp style={{ fontSize: "1.3rem" }} />
                      }
                    >
                      {data.data.smsCode}
                    </Button>
                  );
                }}
              />
              {/* //FIXME: */}
              <Column
                caption="Reserve"
                dataField="reservedPerson"
                alignment="center"
                fixed
                fixedPosition="right"
                cellRender={(data) => {
                  // console.log("Reserve data", data);
                  const rowData = data.data;

                  return data.value === null || data.value === undefined ? (
                    <Button
                      id={`reserve-button-${data.data.id}`}
                      variant="contained"
                      color="success"
                      sx={{
                        width: "11.187rem",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        height: "2.4rem",
                        backgroundColor: "#73B816",
                        "&:hover": {
                          backgroundColor: "#73B816",
                        },
                      }}
                      startIcon={<FiTarget style={{ fontSize: "1.3rem" }} />}
                      onClick={() => {
                        handleReserve(data.data.id);
                      }}
                    >
                      Reserve
                    </Button>
                  ) : data.value === personId ? (
                    <Button
                      id={`in-progress-button-${data.data.id}`}
                      variant="contained"
                      sx={{
                        width: "11.187rem",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        height: "2.4rem",
                        backgroundColor: "#D6336C",
                        "&:hover": {
                          backgroundColor: "#D6336C",
                        },
                      }}
                      startIcon={
                        <RiProgress5Line style={{ fontSize: "1.3rem" }} />
                      }
                    >
                      In Progress
                    </Button>
                  ) : (
                    <Button
                      id={`person-button-${data.data.id}`}
                      variant="contained"
                      sx={{
                        width: "11.187rem",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        height: "2.4rem",
                      }}
                      startIcon={<FaUser style={{ fontSize: "1.3rem" }} />}
                    >
                      {data.data?.reservedPersonName?.length > 7
                        ? `${data.data?.reservedPersonName?.substring(0, 7)}..`
                        : data.data?.reservedPersonName}
                    </Button>
                  );
                }}
              />

              <Column
                caption="Details"
                dataField="detail"
                alignment="center"
                fixed
                fixedPosition="right"
                cellRender={(data) => (
                  <Button
                    variant="contained"
                    id={`detail-button-${data.data.id}`}
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: "700",
                      height: "2.4rem",
                      backgroundColor: "#F59F00",
                      "&:hover": {
                        backgroundColor: "#F59F00",
                      },
                    }}
                    startIcon={<CgDetailsMore style={{ fontSize: "1.3rem" }} />}
                    onClick={() => {
                      if (data.data.reservedPerson === personId) {
                        if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_DISABLE_LOGS !== "true") {
                          console.log("Detail clicked", data.data.reservedPerson);
                        }
                        handleDetailClick(data.data.id);
                      }
                    }}
                  >
                    Detail
                  </Button>
                )}
              />
            </DataGrid>
            <ContextMenu
              dataSource={menuItems}
              target=".dx-row"
              visible={contextMenuVisible}
              onHidden={() => setContextMenuVisible(false)}
              onItemClick={(e) => e.itemData.onClick()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositView;
